import { H3Event, getRequestHeader } from 'h3'

import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'

import { MARKET_COUNTRY_CODE } from '../constants'

import { getMarketFromDomain } from './getMarketFromDomain'

function isMarketCountryCode(value: string): value is MarketCountryCode {
  return value in MarketCountryCode
}

export function getRequestCountryCode(event: H3Event): MarketCountryCode {
  const cloudflare = getRequestHeader(event, MARKET_COUNTRY_CODE)

  if (cloudflare && isMarketCountryCode(cloudflare)) {
    return cloudflare
  }

  // In Nuxt 3.19+, the default forked mode causes the host header to be rewritten
  // to 127.0.0.1:port in development. To test different markets locally, use:
  // `yarn dev --no-fork` to disable forked mode and preserve the original host header.
  // In production, Cloudflare headers are used, so this is development-only
  // https://github.com/nuxt/cli/issues/1088 same issue as us
  return getMarketFromDomain(event.node.req.headers.host ?? '').countryCode
}
